"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDER_ON_BEHALF_DIALOG_BACK_ARROW = exports.ORDER_ON_BEHALF_DIALOG = void 0;
const ORDER_ON_BEHALF_DIALOG = exports.ORDER_ON_BEHALF_DIALOG = 'order-on-behalf-dialog';
const ORDER_ON_BEHALF_DIALOG_BACK_ARROW = exports.ORDER_ON_BEHALF_DIALOG_BACK_ARROW = 'order-on-behalf-dialog-back-arrow';